import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private isLoading = new BehaviorSubject<boolean>(false)
    isLoading$ = this.isLoading.asObservable()

    private loadingMessage = new BehaviorSubject<string>(
        'Cargando. Por favor espere...'
    )
    loadingMessage$ = this.loadingMessage.asObservable()

    show(action: boolean, message: string = 'Cargando. Por favor espere...') {
        this.loadingMessage.next(message)
        this.isLoading.next(action)
    }
}
